export default {
  black: '#161616',
  white: 'white'
}
